import React, { useState } from "react";
import {
    CheckCircle,
    Handshake,
    Users,
    Briefcase,
    Mail,
    User,
    Phone,
    MessageSquare,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import channelImg from '../Img/channel_partner_fin.png'
import Associates from "./Associates";

const ChannelPartners = () => {
    const [activeTab, setActiveTab] = useState("partner");
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const navigate = useNavigate()

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [id.replace('partner-', '')]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const type = activeTab === "partner" ? "CHANNEL PARTNER" : "DSA MODEL";
        try {
            const response = await fetch('https://100billionrealestate.com/partner', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    type
                }),
            });
            if (response.ok) {
                alert('Application submitted successfully!');
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                });
            } else {
                alert('Failed to submit application. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('An error occurred. Please try again.');
        }
    };

    const benefits = [
        "Access to the Mangal Network",
        "No investment required",
        "Revenue sharing on every closure",
        "Timely and transparent payouts",
        "CRM for lead & commission tracking",
        "Training and in-person support",
    ];

    const partnerBenefits = [
        "Join hands with the best in the industry",
        "Enhance relationships with stakeholders",
        "Boost walk-ins with our branding",
        "Increase profitability",
        "Get recovery support from the Mangal team",
        "Dedicated in-house training",
    ];

    const dsaBenefits = [
        "Customer acquisition & loan promotion",
        "Guide clients through loan process & documentation",
        "Bridge gap between lenders and borrowers",
        "Earn attractive commissions",
        "Get backend support from Mangal team",
    ];

    return (
        <>
            <div className="other-pages-main-section channel-page-fin">
                <h2 className="other-pages-title">Channel Partner</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/channel-partner")} style={{ cursor: "pointer" }}> Channel partner</span>
                </p>
            </div>

            <Associates />

            {/* Intro Section */}
            <div className="channel-intro">
                <div className="channel-left">
                    <h2>
                        Become a part of our <span>"Magnify Advaisory"</span>
                    </h2>
                    <p>
                        Want to maximize your business or earn additional income? Our
                        Channel Partner program is designed to help you grow revenues by
                        leveraging the strength of the Mangal network.
                    </p>

                    <ul className="benefits-list">
                        {benefits.map((item, idx) => (
                            <li key={idx}>
                                <CheckCircle className="icon" /> {item}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="channel-right">
                    <img src={channelImg} alt="" />
                </div>
            </div>

            {/* Partner Section */}
            <div className="partner-section">
                <div className="partner-title">
                    <h3>Partner Possibilities</h3>
                    <p>Two simple ways to become our partner</p>
                </div>

                {/* Tabs */}
                <div className="partner-tabs">
                    <button
                        className={activeTab === "partner" ? "active" : ""}
                        onClick={() => setActiveTab("partner")}
                    >
                        CHANNEL PARTNER
                    </button>
                    <button
                        className={activeTab === "dsa" ? "active" : ""}
                        onClick={() => setActiveTab("dsa")}
                    >
                        DSA MODEL
                    </button>
                </div>

                {/* Content */}
                <div className="partner-content">
                    <div className="partner-left">
                        {activeTab === "partner" && (
                            <>
                                <h4>Become a Channel Partner</h4>
                                <ul>
                                    {partnerBenefits.map((item, idx) => (
                                        <li key={idx}>
                                            <CheckCircle className="icon-sm" /> {item}
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}

                        {activeTab === "dsa" && (
                            <>
                                <h4>Become a DSA Agent</h4>
                                <ul>
                                    {dsaBenefits.map((item, idx) => (
                                        <li key={idx}>
                                            <CheckCircle className="icon-sm" /> {item}
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </div>

                    {/* Form */}
                    <div className="partner-form">
                        <form onSubmit={handleSubmit}>
                            <div className="partner-form-row">
                                <div className="partner-input-group">
                                    <label htmlFor="partner-name">Full Name</label>
                                    <input
                                        id="partner-name"
                                        type="text"
                                        placeholder="e.g. Rajesh Kumar Sharma"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="partner-input-group">
                                    <label htmlFor="partner-email">Email Address</label>
                                    <input
                                        id="partner-email"
                                        type="email"
                                        placeholder="e.g. rajesh.sharma@gmail.com"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>

                            <div className="partner-input-group">
                                <label htmlFor="partner-phone">Phone Number</label>
                                <input
                                    id="partner-phone"
                                    type="text"
                                    placeholder="e.g. 9876543210"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="partner-input-group partner-textarea-group">
                                <label htmlFor="partner-message">Enter Message</label>
                                <textarea
                                    id="partner-message"
                                    placeholder="e.g. Enter message "
                                    rows="4"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                ></textarea>
                            </div>

                            <button type="submit" className="partner-submit-btn">
                                SEND
                            </button>
                        </form>
                    </div>


                </div>

                {/* Footer */}
                <div className="partner-footer">
                    <p>
                        Apply to become an authorised partner —{" "}
                        <a href="#">Contact us</a> to learn how you can join the program.
                    </p>
                    <p>Email us at <strong>info@magnifyadvaisory.com</strong></p>
                </div>
            </div>
        </>
    );
};

export default ChannelPartners;
